/**
 * OffertenTab — the Tab-4 body of the Ausschreibungs-Screen («Offerten & Vergleich»). Sub-section 4a
 * (Offert-Posteingang, Slice 10), 4b (KI-Offertvergleich, Slice 11) and 4c (Kundenfreigabe & Entscheid,
 * Slice 12) are all live.
 */

import { OffertPosteingangSection } from './OffertPosteingangSection';
import { VergleichSection } from './VergleichSection';
import { KundenfreigabeSection } from './KundenfreigabeSection';

export function OffertenTab({
  placementId,
  canWrite,
  kundenfreigabeOpenKind = null,
  onKundenfreigabeOpenHandled,
}: {
  placementId: string;
  canWrite: boolean;
  kundenfreigabeOpenKind?: 'zustellen' | 'entscheid' | null;
  onKundenfreigabeOpenHandled?: () => void;
}) {
  return (
    <div className="flex flex-col gap-6" data-testid="placement-offerten-tab">
      <OffertPosteingangSection placementId={placementId} canWrite={canWrite} />

      <VergleichSection placementId={placementId} canWrite={canWrite} />

      <KundenfreigabeSection
        placementId={placementId}
        canWrite={canWrite}
        openKind={kundenfreigabeOpenKind}
        onOpenHandled={onKundenfreigabeOpenHandled}
      />
    </div>
  );
}
